import * as Types from '../constants/Types';

export const getListSiteInfo = (filters) => ({ type: Types.SITEINFO_LIST_ACTION, filters });
export const setListInfos = (siteInfos) => ({ type: Types.SITEINFO_LIST_SUCCESS, siteInfos});

export const getSiteInfoDetail = (id) => ({ type: Types.SITEINFO_DETAIL_ACTION, id })
export const setSiteInfoDetail = (siteinfo) => ({ type: Types.SITEINFO_DETAIL_SUCCESS, siteinfo });

export const updateSiteInfoDetail = (siteinfo) => ({ type: Types.SITEINFO_DETAIL_UPDATE_ACTION, siteinfo });
export const createSiteInfoDetail = (siteinfo) => ({ type: Types.SITEINFO_DETAIL_CREATE_ACTION, siteinfo });
export const deleteSiteInfoDetail = (siteinfo, filters) => ({ type: Types.SITEINFO_DETAIL_DELETE_ACTION, siteinfo, filters });

export const createSiteInfoTranslate = (siteinfo) => ({type: Types.SITEINFO_CREATE_TRANSLATE_ACTION, siteinfo});
export const updateSiteInfoTranslate = (siteinfo) => ({type: Types.SITEINFO_UPDATE_TRANSLATE_ACTION, siteinfo});
export const deleteSiteInfoTranslate = (siteinfo, refreshParams) => ({type: Types.SITEINFO_DELETE_TRANSLATE_ACTION, siteinfo, refreshParams});